import React, { useState } from 'react'

const Contact = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  })
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value })
  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    const endpoint = process.env.REACT_APP_CONTACT_ENDPOINT || ''

    // If no backend endpoint is configured, fallback to mailto (opens user's email client)
    if (!endpoint) {
      const mailto = `mailto:info@rokyetventures.com?subject=${encodeURIComponent(
        form.subject || 'Website Contact'
      )}&body=${encodeURIComponent(
        `Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`
      )}`
      window.location.href = mailto
      return
    }

    setLoading(true)
    try {
      const resp = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          to: 'info@rokyetventures.com',
          name: form.name,
          email: form.email,
          subject: form.subject,
          message: form.message,
        }),
      })

      if (!resp.ok) {
        const text = await resp.text()
        throw new Error(text || 'Failed to send message')
      }

      setSent(true)
      setForm({ name: '', email: '', subject: '', message: '' })
      setTimeout(() => setSent(false), 4000)
    } catch (err) {
      console.error('Contact send error', err)
      setError(err.message || 'Failed to send message')
    } finally {
      setLoading(false)
    }
  }

  return (
    <section id='contact' className='section contact'>
      <div className='container'>
        <div className='section-header'>
          <h2>Contact Us</h2>
          <p>
            Get in touch with us to discuss your software development needs or
            learn more about AroPMIS.
          </p>
        </div>

        <div className='contact-content'>
          <div className='contact-info'>
            <h3>Our Location</h3>
            <p>3rd Floor, Rm 6D, 64 Arcade, Eldoret, Kenya</p>
            <h3>Phone</h3>
            <p>+254 797 922 279 / +254 729 174 776</p>
            <h3>Email</h3>
            <p>info@rokyetventures.com</p>
          </div>

          <div className='contact-form'>
            <form onSubmit={handleSubmit}>
              <div className='form-group'>
                <input
                  className='form-control'
                  name='name'
                  placeholder='Full Name'
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='form-group'>
                <input
                  className='form-control'
                  name='email'
                  placeholder='Email Address'
                  type='email'
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='form-group'>
                <input
                  className='form-control'
                  name='subject'
                  placeholder='Subject'
                  value={form.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='form-group'>
                <textarea
                  className='form-control'
                  name='message'
                  placeholder='Message'
                  rows='5'
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button
                type='submit'
                className='btn btn-accent'
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
            {sent && (
              <div className='alert success'>
                Thank you for your message! We will get back to you soon.
              </div>
            )}
            {error && (
              <div className='alert error' style={{ marginTop: 12 }}>
                {error}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
